// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import FScontent from './PageComponent/FScontent';

function FabricShade() {

    useMeta({
        title: 'Fabric Shade | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/fabric-shade/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Fabric Shade | Callistus Blinds',
            description:
                'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort',
            url: 'https://callistusblinds.com/fabric-shade/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <FScontent />
            <Footer />
        </div>
    );
}

export default FabricShade;
